import eventsAPI from '@/api/resources/events'
import _ from 'lodash'

export default {
  data () {
    return {
      items: [],
      tableHeaders: [
        { text: 'Type', value: 'vendor' },
        { text: 'Message', value: 'message' },
        { text: 'Event', value: 'events_id' },
        { text: 'Recipients', value: 'recipients_string' },
        { text: 'Roles', value: '' },
        { text: 'Send to client', value: 'send_to_client' },
        { text: 'Is active', value: 'is_active' },
        { text: 'Created at', value: 'created_at' },
        { text: 'Updated at', value: 'updated_at' },
        { text: 'Actions', value: 'actions' }
      ],
      notificationTypesList: [
        { value: 'whatsapp', text: 'WhatsApp' },
        { value: 'twilio', text: 'SMS' },
        { value: 'email', text: 'Email' }
      ],
      dialogOpen: false,
      dialogMessage: '',
      eventsList: [],
      selectedEvent: 0,
      notificationRecipients: '',
      notificationMessage: '',
      notificationIsActive: true
    }
  },
  methods: {
    loadListingSuccess (result) {
      result.forEach((notification, i) => {
        notification.recipients_string = ''

        notification.roles_string = ''

        notification.recipients.forEach((recipient, i) => {
          if (notification.vendor === 'email') {
            notification.recipients_string = recipient.email !== null ? notification.recipients_string.concat(recipient.email) : notification.recipients_string
          } else {
            notification.recipients_string = notification.recipients_string.concat(recipient.phone)
          }

          if (i !== notification.recipients.length - 1) {
            notification.recipients_string = notification.recipients_string.concat(', ')
          }
        })

        notification.roles.forEach((recipient, i) => {
          notification.roles_string = notification.roles_string.concat(recipient.phone)

          if (i !== notification.roles.length - 1) {
            notification.roles_string = notification.roles_string.concat(', ')
          }
        })
      })

      this.items = result
    }
  },
  created () {
    eventsAPI.loadEvents().then(result => {
      this.eventsList = _.map(result, (p) => {
        return {
          text: p.description || p.name,
          value: p.id
        }
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/mixins/Notifications.js